<template>
  <article class="event-card">
   <div v-if="event.unread_cnt" class="unread-messages">
     <span class="unread-messages_amount">
       {{ event.unread_cnt }}
     </span>
   </div>
    <event-image
      width="76px"
      height="76px"
      class="event-image"
      :src="eventImage"
      :event-name="eventName"
    />
    <div class="info">
      <h1 class="info__event-title">
        {{ eventName }}
      </h1>
      <div class="info__people-amount" v-if="event && event.contacts && event.contacts.length">
        <b-icon-person-fill/>
        {{event && event.contacts && event.contacts.length || 0}}
      </div>
      <span class="info__date">
        {{  getFormattedDate() }}
      </span>
      <div class="money-distribution">
        <div class="money-distribution__my-turn">
          {{ getPayoutStatus }}
        </div>
        <money-message
          :currency="currency"
          font-size="12px"
          :type="getPayoutType"
          :money-amount="event.balance !== 0 ? event.balance : $t('CP.noDebts')"
        />
      </div>
    </div>
    <button class="event-card__btn-delete" @click="onDeleteEvent(event)">&#215;</button>
  </article>
</template>

<script>
import { mapState } from 'vuex';
import MoneyMessage from '../MoneyMessagge/MoneyMessage';
import EventImage from '../EventImage/EventImage';

export default {
  name: 'EventItem',
  components: {
    EventImage,
    MoneyMessage,
  },
  props: {
    event: {
      type: Object,
      default: () => ({}),
    },
    currency: {
      type: String,
      default: '',
    },
    onDeleteEvent: {
      type: Function,
      default: () => {},
    },
    showUnreadMessages: {
      type: Boolean,
      default: false,
    },
    eventDateMode: {
      type: String,
      default: 'byUpdate',
      validate: (val) => ['byUpdate', 'byCreate'].includes(val),
    },
  },
  watch: {
    locale() {
      this.$forceUpdate();
    },
  },
  computed: {
    ...mapState({
      locale: (state) => state.app.currentLanguage,
      user: (state) => state.user.user,
    }),
    eventImage() {
      if (this.event && this.user) {
        if (this.event.image_url) {
          return this.event.image_url;
        }
        if (!this.event.event_name && this.event.contacts) {
          const quasiUser = this.event.contacts
            .find((contact) => contact.uid !== this.user.user).avatar_url;
          if (quasiUser) {
            return quasiUser;
          }
        }
      }
      return '';
    },
    eventName() {
      if (this.event && this.user) {
        if (this.event.event_name) {
          return this.event.event_name;
        }
        if (this.event.quasi_event_name) {
          return this.event.quasi_event_name;
        }
        if (this.event.contacts) {
          const quasiUser = this.event.contacts
            .find((contact) => contact.uid !== this.user.user);
          const quasiUserName = this.$getUserName(quasiUser);
          if (quasiUserName) {
            return quasiUserName;
          }
        }
      }
      return '';
    },
    getPayoutStatus() {
      if (this.event.balance < 0) {
        return this.$t('CP.myTurnToPay');
      }
      return '';
    },
    getPayoutType() {
      const { balance } = this.event;
      if (balance > 0) {
        return 'accrual';
      }
      if (balance < 0) {
        return 'debit';
      }
      return 'neutral';
    },
  },
  methods: {
    getFormattedDate() {
      try {
        let dateMode;
        if (this.eventDateMode === 'byUpdate') {
          dateMode = 'mod_date';
        } else {
          dateMode = 'cr_date';
        }
        const locale = localStorage.getItem('locale') || this.$store.state.app.currentLanguage;
        const eventDate = this.$moment(`${this.event[dateMode]}Z`).locale(locale);
        const now = this.$moment();
        this.$moment.locale(localStorage.getItem('locale') || this.$store.state.app.currentLanguage);
        // if (crDate.date() === now.date() && crDate.month() === now.month()
        //   && crDate.year() === now.year()) {
        //   return crDate.calendar();
        // }
        if (now.diff(eventDate, 'days') <= 5) {
          return eventDate.calendar().replace(/,/g, '');
        }
        return eventDate.format('LL');
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('error in dateFormat:');
        // eslint-disable-next-line no-console
        console.error(e);
        return '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .event-card {
    display: flex;
    word-break: break-word;
  }

  .unread-messages {
    align-items: center;
    border-radius: 6px 0 10px 0;
    background: var(--btn-primary);
    color: #fff;
    display: flex;
    font-size: 11px;
    height: 18px;
    justify-content: center;
    left: 0;
    min-width: 20px;
    padding: 0 5px;
    position: absolute;
    text-align: center;
    top: 0;
  }
  /*.unread-messages_amount*/

  .event-image {
    margin-right: 8px;
    width: 76px;
    height: 76px;
  }

  .info {
    flex: 1 1 70%;
    display: flex;
    flex-wrap: wrap;
  }

  .info__event-title {
    margin: 0;
    flex: 0 1 70%;
    font-size: 16px;
  }

  .info__people-amount {
    flex: 0 1 30%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    max-height: 20px;
    font-size: 11px;
    color: var(--text-seccond-color);
  }

  .info__date {
    flex: 0 1 100%;
    font-size: 12px;
    line-height: 16px;
    opacity: 0.6;
  }

  .money-distribution {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 0 0 100%;
    font-size: 12px;
  }

  .money-distribution__my-turn {
    opacity: 0.7;
  }

  .money-distribution__debt-amount {
    color: #D32F2F;
    line-height: 22px;
  }

  .event-card__btn-delete {
    display: none;
    position: absolute;
    right: -5px;
    top: -5px;
    font-size: 1.6rem;
    border: none;
    color: var(--error-red);
    background: transparent;
  }
</style>
